import { render, staticRenderFns } from "./AssetStatesConfig.vue?vue&type=template&id=8a49df34&scoped=true"
import script from "./AssetStatesConfig.vue?vue&type=script&lang=js"
export * from "./AssetStatesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a49df34",
  null
  
)

export default component.exports